import React, { ChangeEvent, HTMLInputTypeAttribute } from "react";

type Props = {
  id?: string;
  name?: string;
  value?: string | number;
  type?: HTMLInputTypeAttribute;
  inputMode?: NonNullable<JSX.IntrinsicElements["input"]["inputMode"]>;
  autoComplete?: string;
  defaultValue?: string;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void | Promise<void>;
  placeholder?: string;
  ariaLabelledby?: string;
  hasError?: boolean;
  isReadOnly?: boolean;
  disabled?: boolean;
  className?: string;
  maxLength?: number;
};

export const InputText: React.FC<Props> = (props) => {
  const {
    id,
    name,
    type = "text",
    defaultValue,
    value,
    onChange,
    onBlur,
    onFocus,
    onKeyDown,
    placeholder,
    hasError,
    isReadOnly,
    inputMode,
    ariaLabelledby,
    autoComplete,
    disabled,
    className,
    maxLength,
    ...other
  } = props;
  const border = hasError
    ? "!border-accent focus:border-accent"
    : "border-theme-medium";

  return (
    <input
      type={type}
      id={id}
      name={name}
      value={value}
      defaultValue={defaultValue}
      onChange={onChange}
      onBlur={onBlur}
      onFocus={onFocus}
      onKeyDown={onKeyDown}
      placeholder={placeholder}
      className={["w-full h-11", className, border].join(" ")}
      readOnly={isReadOnly}
      aria-labelledby={ariaLabelledby}
      inputMode={inputMode}
      autoComplete={autoComplete}
      disabled={disabled}
      onWheel={(e) => {
        if (type === "number") {
          e.currentTarget.blur();
        }
      }}
      maxLength={maxLength}
      {...other}
    />
  );
};
